// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3oBGY","gfeWrapper":"CalendarEvent_gfeWrapper__2gZ6d"};